// Modules
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDrop } from "react-dnd";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdKmApi, AdKmGetApi, AdKmCatApi, AdKmUploadApi, AdKmSgApi } from "_Route/Api";
import uuid from "react-uuid";
import Loading from "Admin/Component/Loading";
import { uploadPlugin } from "Admin/Component/AdFunc";
import DefaultCKEditor from "Admin/Component/DefaultCKEditor";


const AdKMView = ({curSpace, update, setUpdate, updateMenu, setUpdateMenu}) => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [, drop] = useDrop(() => ({ accept: 'List' })) // React-dnd - useDrop

  const [loading, setLoading] = useState(false)

  const sessionID = localStorage.getItem('memSessionID')
  const userName = useSelector(state => state.authorityAcc.name);
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  const imgHost = process.env.REACT_APP_IMG_HOST;

  const [adKmMenu, setAdKmMenu] = useState([]); // 전체 KM Menu Data
  const [curKmMenu, setCurKmMenu] = useState([]) // 현재 KM Menu Data

  const curType = location.pathname.split('/')[3] === 'add' ? '등록' : '수정'; // 관리 Type
  const curScore = location.pathname.split('/')[3] === 'add' ? 200 : 300; // 관리 Type
  const useGroup = ['미사용', '사용']; // 사용 여부 배열

  const [catList, setCatList] = useState([]);
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm'); // 현재 날짜 및 시간
  
  const [info, setInfo] = useState({ // 전체 Input Data 배열
    km_index: '',
    km_menu_use: 1,
    km_title: '',
    km_content: '',
    km_group: '', // Number
    km_parent: '',
    km_depth: '',
    km_create_user: "",
    km_last_modify_user: userName,
    km_file: undefined,
    km_dfile: undefined,
    approve_spec_status: 0,
    approve_ap_status: 0,
  }) 
  const { km_group, km_menu_use, km_title, km_content } = info;

  const [fileName, setFileName] = useState([]);


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // Input onChange Func
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }

  // onChange Info - File URL
  const onChangeFile = () => {
    let fileArrTemp = []
    fileName.map(list => {
      if (km_content.includes(list)) {
        fileArrTemp.push(list)
      }
    })
    const dfile = fileName.filter(it => !fileArrTemp.includes(it))

    setInfo({
      ...info,
      km_file: fileArrTemp.length !== 0 ? fileArrTemp : undefined,
      km_dfile: dfile.length !== 0 ? dfile : undefined,
    })
  }


  /*========================================================================
  * GET KM Data
  ========================================================================*/
  // 현재 KM 메뉴 조회
  useEffect(() => {
    setLoading(false)
    axios.get(AdKmSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        km_id: params.id
      }
    })
    .then(res => {
      // console.log(res, "GET KM Data Success!");
      const curKm = res.data.result[0]
      setCurKmMenu(curKm)
      
      if(curKm === undefined && params.id !== undefined) {
        navigate('/404');
      }
      if(curType === '수정' && curKm.km_file) {
        setFileName(JSON.parse(curKm.km_file));
      }
      setInfo({
        km_index: curType === '수정' ? curKm?.km_index : '',
        km_menu_use: curType === '수정' ? curKm?.km_menu_use : 1,
        km_title: curType === '수정' ? curKm?.km_title : '',
        km_content: curType === '수정' ? curKm?.km_content : '', 
        km_group: curKm?.km_group ?? (curSpace === '' ? '1' : curSpace),
        km_parent: curType === '수정' ? curKm?.km_parent : curKm?.km_id,
        km_depth: curType === '수정' ? curKm?.km_depth : params.id === undefined ? 0 : curKm?.km_depth + 1,
        km_create_user: userName,
        km_last_modify_user: userName,
        km_file: curType === '수정' && curKm.km_file ? curKm.km_file : undefined,
        km_dfile: undefined,
        approve_spec_status: 0,
        approve_ap_status: 0,
      })
    })
    .catch(err => {
      console.error(err, "GET KM Data Error...");
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, curSpace])


  // 전체 KM 메뉴 조회
  useEffect(() => {
    axios.get(AdKmGetApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setAdKmMenu(res.data.result)
    })
    .catch(err => {
      console.error(err, "err")
    })
  }, [update, updateMenu])


  // KM 카테고리 목록 조회
  useEffect(() => {
    axios.get(AdKmCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setCatList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET Category List Error...");
    })
  }, [curSpace])


  /*========================================================================
  * KM 등록, 수정, 삭제 [POST, PUT, DELETE]
  ========================================================================*/
  // KM 등록
  const postKM = () => {
    axios({
      url: AdKmApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`새 메뉴 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      setUpdateMenu(!updateMenu)
      // setUpdate(!update)
      setInfo({...info, km_content: '', km_title: '', km_file: '', km_dfile: ''})
      setFileName([]);
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `KM POST Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  // KM 수정
  const updateKM = () => {
    const tempInfo = info;
    tempInfo.km_id = params.id

    axios({
      url: AdKmApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: tempInfo
    })
    .then(res => {
      alert(`메뉴 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      setUpdateMenu(!updateMenu)
      // setUpdate(!update)
    })
    .catch(err => {
      console.error(err, "KM PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  // KM 삭제
  const deleteKM = (id, index, arrCol) => {
    axios({
      url: AdKmApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        km_id: id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      if(index === arrCol.length - 1) {
        alert(`${arrCol.length}개의 메뉴 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdateMenu(!updateMenu)
      // setUpdate(!update)
      navigate('/admin/km/add')
    })
    .catch(err => {
      console.error(err, "KM DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }

  const KmConfirm = () => {
    if (km_title === '') { alert("제목을 입력해주세요.") }
    else if (km_content === '') { alert("내용을 입력해주세요.") }
    else {
      if (curType === '수정') { updateKM() }
      else { postKM() }
    }
  }

  // KM 하위 메뉴 일괄삭제 함수
  const DeleteFunc = () => {

    const selectMenu = adKmMenu.filter(key => key.km_id === params.id)
    const delIdArr = [];

    const TreeFunc = (data, state = true) => {
      data.map(key => {
        const nextDepth = adKmMenu?.filter(list => key.km_id === list.km_parent && list.km_depth !== 0)
        const prevDepth = adKmMenu?.filter(list => list.km_id === key.km_parent)
      
        delIdArr.push(key.km_id)

        if (state === true && nextDepth.length === 0) { return 0 }
        else if(nextDepth.length !== 0 && key.children === undefined) {
          key.children = nextDepth
          TreeFunc(nextDepth, false)
        }
        else if (nextDepth.length === 0) {
          TreeFunc(prevDepth, false)
        }
      })
    }
    TreeFunc(selectMenu)

    const setCollection = new Set(delIdArr);
    const arrCol = [...setCollection];

    if(window.confirm(`삭제 대상: ${selectMenu[0].km_title}\n\n하위 메뉴 포함 총 ${arrCol.length}개의 메뉴가 삭제됩니다.\n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
      arrCol.map((item, i) => {
        deleteKM(item, i, arrCol)
      })
    }
  }


  return (
    <div ref={drop} className={`adContArea detail ${update ? 'on' : 'off'}`}>
      {loading ?
        <React.Fragment>
          <fieldset className="left">
            <legend>KM 글 수정</legend>

            {/* 사용여부 [km_menu_use] */}
            <div className="fieldGroup row">
              <label>사용여부<span className="redTxt">*</span></label>

              <div className="field">
                {useGroup.map((item, i) =>
                  <div className="checkGroup" key={i}>
                    <input type="radio" className="check sm blue" name="km_menu_use" id={`km_menu_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(km_menu_use) === i}/>
                    <label htmlFor={`km_menu_use_${i}`}></label>

                    <label htmlFor={`km_menu_use_${i}`}>{item}</label>
                  </div>
                )}
              </div>
            </div>

            {/* 카테고리 [km_group] */}
            <div className="fieldGroup row">
              <label>카테고리</label>

              <div className="field">
                <select className="select md round_10 type_1" name="km_group" onChange={(e) => onChange(e)} defaultValue={km_group} key={uuid()}>
                  {catList.map((key, i) =>
                    <option key={i} value={key.kmgrp_no}>{key.km_grp}</option>
                  )}
                </select>
              </div>
            </div>

            {/* 현재 메뉴 제목 */}
            {
              curKmMenu && curType === "등록" &&
              <div className="fieldGroup row">
                <label>현재 메뉴 제목</label>

                <div className="field full">
                  <input type="text" className="input md round_10" value={curKmMenu.km_title ?? ''} disabled />
                </div>
              </div>
            }

            {/* 제목 [km_title] */}
            <div className="fieldGroup row">
              <label>제목<span className="redTxt">*</span></label>

              <div className="field full">
                <input type="text" className="input md round_10" name="km_title" onChange={(e) => onChange(e)} value={km_title} placeholder="제목을 입력해주세요." />
              </div>
            </div>

            {/* Import */}
            {/* <div className="fieldGroup row">
              <label>Import<span className="redTxt">*</span></label>

              <div className="field">
                <button type="button" className="btn xs sfrtBlue round_10">임포트할 내용 선택</button>
              </div>
            </div> */}

            {/* 내용 [km_content] */}
            <div className="fieldGroup row">
              <label>내용<span className="redTxt">*</span></label>

              <div className="field full">
                <DefaultCKEditor
                  config={{placeholder: "내용을 입력하세요."}}
                  onReady={(editor) => {
                    uploadPlugin(editor, AdKmUploadApi, setFileName)
                  }}
                  data={km_content}
                  onChange={(event, editor) => {
                    setInfo({...info, km_content: editor.getData()})
                  }}
                  onBlur={() => onChangeFile()}
                />
              </div>
            </div>

            {/* 작성/수정자 */}
            <div className="fieldGroup row">
              <label>{curType}자</label>

              <div className="field full">
                <input type="text" className="input md round_10" value={userName} disabled />
              </div>
            </div>

            {/* 작성/수정 일시 */}
            <div className="fieldGroup row">
              <label>{curType} 일시</label>

              <div className="field full">
                <input type="text" className="input md round_10" value={curDate} disabled />
              </div>
            </div>
          </fieldset>

          <div className="btnArea">
            {
              userScore >= curScore &&
              <button type="button" className="btn sm sfrtBlue round_10" onClick={() => KmConfirm()}>{curType}{master === 1 ? '' : ' 요청'}</button>
            }
            <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/km/list')}>취소</button>
            {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => DeleteFunc()}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
          </div>
        </React.Fragment>
        :
        <Loading />
      }
    </div>
  )
}

export default AdKMView;